import { render, staticRenderFns } from "./RMAAssistance.vue?vue&type=template&id=003c339f"
import script from "./RMAAssistance?vue&type=script&lang=ts&external"
export * from "./RMAAssistance?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports